// extracted by mini-css-extract-plugin
export var modal = "_tw-0";
export var table = "_tw-1";